import './App.css';
//import { handleToggleCamera, handleCapture, handleClear } from './camera.js';
import { useCamera } from './camera.js';
//import { handleCapture, handleClear, handleToggleCamera } from './camera.js'
import { useRef, useState } from 'react';
import { handleFormSubmit, handleIngradientList } from './FoodSearch.js';
// import Button from 'react-bootstrap/Button';
import { getHealthValue } from './health.js';


function App() {
  //const videoRef = useRef(null);
  //const { ocrSpace } = require('ocr-space-api-wrapper');

  const [searchedIngradiant, setSearchedIngradiant] = useState(null);
  const fileInputRef = useRef(null);
  //const [image, setImage] = useState(null);
  //const [processedText, setProcessedText] = useState('');
  const [test, setTest] = useState(["milk", "milk", "milk"]);
  const [ingradiantList, setIngradiantList] = useState(null);

  const {
    videoRef,
    canvasRef,
    handleToggleCamera,
    handleCapture,
    handleClear,
    recognizeText,
  } = useCamera();

  const handleCaptureAndSave = async () => {
    try {
      const response = await handleCapture(); // Capture image and get processed text
      setTest([]);
      setTest(response.processedText); // Save processed text
    } catch (error) {
      console.error('Error capturing image:', error);
    }
  };

  const handleChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = function (e) {
        if (e.target === null) {
          return;
        }
        const img = new window.Image();
        img.src = e.target.result;
        img.onload = async () => {
          //setImage(img);
          const result = await recognizeText(img);
          console.log('result', result);
          if (Array.isArray(result)) {

            setTest(result);
          } else {
            console.error('Error: result is not an array1');
          }

        };
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  // const handleFileChange = (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const reader = new FileReader();
  //     reader.onload = function (e) {
  //       if (e.target === null) {
  //         return;
  //       }
  //       const img = new window.Image();
  //       img.src = e.target.result;
  //       img.onload = () => {
  //         setImage(img);

  //       };
  //       //call capture to run the image through the OCR

  //     };
  //     reader.readAsDataURL(e.target.files[0]);
  //   }
  // };

  // const handleUpload = () => {
  //   fileInputRef.current && fileInputRef.current.click();
  // };

  // const handleFile = (event) => {
  //   const file = event.target.files[0];
  //   const apiKey = "K88923691488957";

  //   const formData = new FormData();
  //   formData.append('file', file);

  //   fetch('https://api.ocr.space/parse/image', {
  //     method: 'POST',
  //     headers: {
  //       'apikey': apiKey
  //     },
  //     body: formData
  //   })
  //     .then(response => response.json())
  //     .then(result => console.log(result))
  //     .catch(error => console.log('error', error));
  // };



  return (
    <div id="App">
      <header className="App-header">
        NutritionChecker
      </header>

      <input
        type="file"
        onChange={handleChange} // Fixed to use the handleChange function
        ref={fileInputRef} // Fixed the ref to use the useRef hook correctly
        style={{ display: 'none' }} // Hide the input element
      />
      <div id='canvas'></div>
      <div id='videoCo'>
        <div id="videoContainer">
          <video ref={videoRef} autoPlay></video>
        </div>
      </div>
      <div className="button-container" style={{ justifyContent: 'center' }}>

        <label> <span>Open Camera</span> </label>
        <label className="switch">
          <input type="checkbox" onChange={handleToggleCamera} />
          <span className="slider round"></span>
        </label>
        <button variant="outline-primary" onClick={handleCaptureAndSave}>Capture</button>
        <button variant="outline-primary" onClick={handleClear}>Clear</button>
        <input type="file" ref={fileInputRef} onChange={handleChange} style={{ display: 'none' }} />
        <button type="button" onClick={() => fileInputRef.current && fileInputRef.current.click()}>Upload Image</button>
        <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
      </div>

      <form id="foodForm" style={{ display: 'flex', justifyContent: 'center' }} onSubmit={(event) => handleFormSubmit(event, setSearchedIngradiant)}>
        <label htmlFor="foodname" class="p-2 bg-light border" >Search Food:</label>
        <input type="text" id="foodname" name="foodname" /><br /><br />
        <input variant="outline-primary" type="submit" value="Submit" />
      </form>
      <div id="searchedIngradiant">
        {searchedIngradiant && <p>{searchedIngradiant.description}</p>}
      </div>
      <div className='IngredientList' id="IngredientList">
        <ul>
          {ingradiantList && ingradiantList.map((ingredient, index) => (
            <li key={index}>
              <div className="listItem">
                <h4 className='Ingredient' id={`Ingredient${index + 1}`}>{ingredient.description}</h4>
                <div className='progressWrap'>
                  <progress className='progressBar' id={`progressBar${index + 1}`} value={getHealthValue(ingredient)} max='100'></progress>
                  <p className='percentage' id={`percentage${index + 1}`}>{getHealthValue(ingredient)}</p>
                </div>
                <a className="Info" id={`Info${index + 1}`} href='https://en.wikipedia.org/wiki/Food'>More Info</a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }} >
        <button onClick={() => handleIngradientList(test, setIngradiantList)}>Load Ingredients</button>
        <script>
          const healthScores = calculateHealthScores(ingredientList);
          console.log('Health Scores:', healthScores);
        </script>
      </div>
    </div >

  )
};



export default App;
